/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitSetPaycheckAllocationAmount} from '../api'

export const useMutationSubmitSetPaycheckAllocationAmount = createReactQueryMutationHook('submitSetPaycheckAllocationAmount', submitSetPaycheckAllocationAmount)
